module.exports = {"component":"panel","status":"prototype","display-name":"Panels","SLDS-component-path":"/components/panels","dependencies":[{"component":"filtering/group"},{"component":"filtering/list-heading"},{"component":"filtering/list"}],"url-slug":"panels"}


//////////////////
// WEBPACK FOOTER
// ./components/panel/docs.json
// module id = 271
// module chunks = 0